class FetchAiCostSummary {
	constructor(
		public readonly accountId: number,
		// Already composed by the `AiCostsFilterView` (`from`, `to`, axis filters).
		public readonly queryParams: URLSearchParams,
	) {
		Object.freeze(this);
	}

	/** Identifies the period and filters, so the store can keep one summary per combination. */
	get queryKey(): string {
		return this.queryParams.toString();
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}
}

export default FetchAiCostSummary;
